import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  GetWorkOrder,
  GetWorkOrderVariables,
  GetWorkOrder_homework_getWorkOrder as WorkOrder,
} from '../../athena/types/GetWorkOrder';
import { WorkOrderFields } from '../../fragments/homework/WorkOrder';

export const GET_WORK_ORDER = gql`
  query GetWorkOrder($id: String!) {
    homework {
      getWorkOrder(input: { id: $id }) {
        ...WorkOrderFields
      }
    }
  }
  ${WorkOrderFields}
`;

export default buildQueryHook<GetWorkOrder, GetWorkOrderVariables, WorkOrder | null>(
  GET_WORK_ORDER,
  {
    wrangler: (data) => data?.homework?.getWorkOrder ?? null,
  },
);
